// Data tabel berat untuk berbagai material baja

export const weightTableData = {
  'pipa': {
    name: 'Pipa Besi',
    nameEn: 'Steel Pipe',
    description: 'Tabel berat pipa besi per meter',
    descriptionEn: 'Steel pipe weight table per meter',
    headers: ['Ukuran (inch)', 'Diameter Luar (mm)', 'Tebal (mm)', 'Berat (kg/m)'],
    headersEn: ['Size (inch)', 'Outer Diameter (mm)', 'Thickness (mm)', 'Weight (kg/m)'],
    data: [
      ['1/2"', '21.3', '2.77', '1.27'],
      ['3/4"', '26.7', '2.87', '1.69'],
      ['1"', '33.4', '3.38', '2.50'],
      ['1 1/4"', '42.2', '3.56', '3.39'],
      ['1 1/2"', '48.3', '3.68', '4.05'],
      ['2"', '60.3', '3.91', '5.44'],
      ['2 1/2"', '73.0', '5.16', '8.63'],
      ['3"', '88.9', '5.49', '11.29'],
      ['4"', '114.3', '6.02', '16.07'],
      ['5"', '141.3', '6.55', '21.77'],
      ['6"', '168.3', '7.11', '28.26'],
      ['8"', '219.1', '8.18', '42.55'],
      ['10"', '273.0', '9.27', '60.31'],
      ['12"', '323.9', '9.52', '73.86']
    ]
  },
  'cnp': {
    name: 'Kanal CNP',
    nameEn: 'CNP Channel',
    description: 'Tabel berat kanal CNP per meter',
    descriptionEn: 'CNP channel weight table per meter',
    headers: ['Ukuran (mm)', 'Tinggi (mm)', 'Lebar (mm)', 'Tebal Web (mm)', 'Tebal Flange (mm)', 'Berat (kg/m)'],
    headersEn: ['Size (mm)', 'Height (mm)', 'Width (mm)', 'Web Thick (mm)', 'Flange Thick (mm)', 'Weight (kg/m)'],
    data: [
      ['75', '75', '40', '5', '7', '6.47'],
      ['100', '100', '50', '5', '7.5', '9.56'],
      ['125', '125', '65', '5.5', '8', '13.72'],
      ['150', '150', '75', '6', '9', '18.48'],
      ['175', '175', '75', '6.5', '9.5', '21.92'],
      ['200', '200', '80', '7', '10', '26.22'],
      ['250', '250', '90', '9', '12', '38.45'],
      ['300', '300', '100', '10', '13', '51.93']
    ]
  },
  'unp': {
    name: 'Kanal UNP',
    nameEn: 'UNP Channel',
    description: 'Tabel berat kanal UNP per meter',
    descriptionEn: 'UNP channel weight table per meter',
    headers: ['Ukuran (mm)', 'Tinggi (mm)', 'Lebar (mm)', 'Tebal Web (mm)', 'Tebal Flange (mm)', 'Berat (kg/m)'],
    headersEn: ['Size (mm)', 'Height (mm)', 'Width (mm)', 'Web Thick (mm)', 'Flange Thick (mm)', 'Weight (kg/m)'],
    data: [
      ['80', '80', '45', '6', '8', '8.64'],
      ['100', '100', '50', '6', '8.5', '10.60'],
      ['120', '120', '55', '7', '9', '13.40'],
      ['140', '140', '60', '7', '10', '16.00'],
      ['160', '160', '65', '7.5', '10.5', '18.80'],
      ['180', '180', '70', '8', '11', '22.00'],
      ['200', '200', '75', '8.5', '11.5', '25.30'],
      ['220', '220', '80', '9', '12.5', '29.40'],
      ['240', '240', '85', '9.5', '13', '33.20'],
      ['260', '260', '90', '10', '14', '37.90'],
      ['280', '280', '95', '10', '15', '41.80'],
      ['300', '300', '100', '10', '16', '46.20']
    ]
  },
  'hbeam': {
    name: 'H-Beam',
    nameEn: 'H-Beam',
    description: 'Tabel berat H-Beam per meter',
    descriptionEn: 'H-Beam weight table per meter',
    headers: ['Ukuran (mm)', 'Tinggi (mm)', 'Lebar Flange (mm)', 'Tebal Web (mm)', 'Tebal Flange (mm)', 'Berat (kg/m)'],
    headersEn: ['Size (mm)', 'Height (mm)', 'Flange Width (mm)', 'Web Thick (mm)', 'Flange Thick (mm)', 'Weight (kg/m)'],
    data: [
      ['100x100', '100', '100', '6', '8', '17.20'],
      ['125x125', '125', '125', '6.5', '9', '23.80'],
      ['150x150', '150', '150', '7', '10', '31.50'],
      ['175x175', '175', '175', '7.5', '11', '40.20'],
      ['200x200', '200', '200', '8', '12', '50.00'],
      ['250x250', '250', '250', '9', '14', '72.40'],
      ['300x300', '300', '300', '10', '15', '94.50'],
      ['350x350', '350', '350', '12', '19', '137.00'],
      ['400x400', '400', '400', '13', '21', '172.00']
    ]
  },
  'inp': {
    name: 'INP / I-Beam',
    nameEn: 'INP / I-Beam',
    description: 'Tabel berat INP per meter',
    descriptionEn: 'INP weight table per meter',
    headers: ['Ukuran (mm)', 'Tinggi (mm)', 'Lebar Flange (mm)', 'Tebal Web (mm)', 'Tebal Flange (mm)', 'Berat (kg/m)'],
    headersEn: ['Size (mm)', 'Height (mm)', 'Flange Width (mm)', 'Web Thick (mm)', 'Flange Thick (mm)', 'Weight (kg/m)'],
    data: [
      ['80', '80', '42', '3.9', '5.9', '5.94'],
      ['100', '100', '50', '4.5', '6.8', '8.34'],
      ['120', '120', '58', '5.1', '7.7', '11.10'],
      ['140', '140', '66', '5.7', '8.6', '14.30'],
      ['160', '160', '74', '6.3', '9.5', '17.90'],
      ['180', '180', '82', '6.9', '10.4', '21.90'],
      ['200', '200', '90', '7.5', '11.3', '26.20'],
      ['220', '220', '98', '8.1', '12.2', '31.10'],
      ['240', '240', '106', '8.7', '13.1', '36.20'],
      ['260', '260', '113', '9.4', '14.1', '41.90'],
      ['280', '280', '119', '10.1', '15.2', '47.90'],
      ['300', '300', '125', '10.8', '16.2', '54.20']
    ]
  },
  'iwf': {
    name: 'IWF / Wide Flange',
    nameEn: 'IWF / Wide Flange',
    description: 'Tabel berat IWF per meter',
    descriptionEn: 'IWF weight table per meter',
    headers: ['Ukuran (mm)', 'Tinggi (mm)', 'Lebar Flange (mm)', 'Tebal Web (mm)', 'Tebal Flange (mm)', 'Berat (kg/m)'],
    headersEn: ['Size (mm)', 'Height (mm)', 'Flange Width (mm)', 'Web Thick (mm)', 'Flange Thick (mm)', 'Weight (kg/m)'],
    data: [
      ['100x50', '100', '50', '5', '7', '9.36'],
      ['125x60', '125', '60', '6', '8', '13.10'],
      ['150x75', '150', '75', '5', '7', '14.30'],
      ['175x90', '175', '90', '5', '8', '18.20'],
      ['200x100', '200', '100', '5.5', '8', '21.50'],
      ['250x125', '250', '125', '6', '9', '29.70'],
      ['300x150', '300', '150', '6.5', '9', '37.30'],
      ['350x175', '350', '175', '7', '11', '49.40'],
      ['400x200', '400', '200', '8', '13', '66.00'],
      ['450x200', '450', '200', '9', '14', '76.50'],
      ['500x200', '500', '200', '10', '16', '90.70']
    ]
  },
  'pipa-kotak': {
    name: 'Pipa Kotak',
    nameEn: 'Hollow Section / Box Pipe',
    description: 'Tabel berat pipa kotak per meter',
    descriptionEn: 'Hollow section weight table per meter',
    headers: ['Ukuran (mm)', 'Tebal (mm)', 'Berat (kg/m)'],
    headersEn: ['Size (mm)', 'Thickness (mm)', 'Weight (kg/m)'],
    data: [
      ['20x20', '1.2', '0.71'],
      ['25x25', '1.2', '0.90'],
      ['30x30', '1.6', '1.42'],
      ['40x40', '1.6', '1.92'],
      ['40x40', '2.0', '2.35'],
      ['50x50', '2.0', '3.02'],
      ['50x50', '3.0', '4.32'],
      ['60x60', '2.0', '3.65'],
      ['60x60', '3.0', '5.28'],
      ['75x75', '3.0', '6.78'],
      ['100x100', '3.0', '9.28'],
      ['100x100', '4.0', '12.20'],
      ['125x125', '4.0', '15.50'],
      ['150x150', '4.5', '21.20'],
      ['150x150', '6.0', '27.70']
    ]
  },
  'pipa-boiler': {
    name: 'Pipa Boiler',
    nameEn: 'Boiler Pipe',
    description: 'Tabel berat pipa boiler per meter',
    descriptionEn: 'Boiler pipe weight table per meter',
    headers: ['Ukuran (inch)', 'Diameter Luar (mm)', 'Tebal (mm)', 'Berat (kg/m)'],
    headersEn: ['Size (inch)', 'Outer Diameter (mm)', 'Thickness (mm)', 'Weight (kg/m)'],
    data: [
      ['1"', '33.4', '3.4', '2.55'],
      ['1 1/4"', '42.2', '3.6', '3.48'],
      ['1 1/2"', '48.3', '3.7', '4.15'],
      ['2"', '60.3', '3.9', '5.56'],
      ['2 1/2"', '73.0', '5.2', '8.77'],
      ['3"', '88.9', '5.5', '11.50'],
      ['4"', '114.3', '6.0', '16.30'],
      ['5"', '141.3', '6.6', '22.30'],
      ['6"', '168.3', '7.1', '28.90']
    ]
  },
  'assental': {
    name: 'Asental',
    nameEn: 'Round Bar / Asental',
    description: 'Tabel berat besi as (round bar) standar panjang 6 meter',
    descriptionEn: 'Round bar weight table (standard 6 meters length)',
    headers: ['Diameter (mm)', 'Berat (kg/m)', 'Berat per Batang (kg/6m)'],
    headersEn: ['Diameter (mm)', 'Weight (kg/m)', 'Weight per Bar (kg/6m)'],
    data: [
      ['6', '0.22', '1.33'],
      ['8', '0.40', '2.37'],
      ['9', '0.50', '3.00'],
      ['10', '0.62', '3.70'],
      ['12', '0.89', '5.33'],
      ['14', '1.21', '7.26'],
      ['16', '1.58', '9.47'],
      ['19', '2.23', '13.36'],
      ['22', '2.98', '17.90'],
      ['25', '3.85', '23.12'],
      ['28', '4.83', '29.00'],
      ['32', '6.31', '37.88'],
      ['36', '7.99', '47.94'],
      ['40', '9.86', '59.19'],
      ['50', '15.41', '92.48'],
      ['60', '22.19', '133.17']
    ]
  },
  'besi-siku': {
    name: 'Besi Siku Sama Sisi',
    nameEn: 'Equal Angle Bar',
    description: 'Tabel berat besi siku tidak sama sisi per meter',
    descriptionEn: 'Unequal angle bar weight table per meter',
    headers: ['Ukuran (mm)', 'Tebal (mm)', 'Berat (kg/m)'],
    headersEn: ['Size (mm)', 'Thickness (mm)', 'Weight (kg/m)'],
    data: [
      ['20x20', '3', '0.88'],
      ['25x25', '3', '1.12'],
      ['30x30', '3', '1.36'],
      ['40x40', '3', '1.85'],
      ['40x40', '4', '2.42'],
      ['40x40', '5', '2.97'],
      ['50x50', '4', '3.06'],
      ['50x50', '5', '3.77'],
      ['50x50', '6', '4.47'],
      ['60x60', '5', '4.57'],
      ['60x60', '6', '5.42'],
      ['70x70', '6', '6.38'],
      ['70x70', '7', '7.38'],
      ['75x75', '6', '6.85'],
      ['75x75', '7', '7.93'],
      ['80x80', '8', '9.63'],
      ['90x90', '9', '12.20'],
      ['100x100', '10', '15.00'],
      ['125x125', '12', '22.80'],
      ['150x150', '15', '33.80']
    ]
  }
};

export const weightTableCategories = [
  { id: 'pipa', icon: '🔧', color: 'from-blue-500 to-blue-600' },
  { id: 'cnp', icon: '⚙️', color: 'from-indigo-500 to-indigo-600' },
  { id: 'unp', icon: '🔩', color: 'from-purple-500 to-purple-600' },
  { id: 'hbeam', icon: '🏗️', color: 'from-pink-500 to-pink-600' },
  { id: 'inp', icon: '🔨', color: 'from-red-500 to-red-600' },
  { id: 'iwf', icon: '⚒️', color: 'from-orange-500 to-orange-600' },
  { id: 'pipa-kotak', icon: '📦', color: 'from-yellow-500 to-yellow-600' },
  { id: 'pipa-boiler', icon: '🔥', color: 'from-green-500 to-green-600' },
  { id: 'assental', icon: '📐', color: 'from-teal-500 to-teal-600' },
  { id: 'besi-siku', icon: '📏', color: 'from-cyan-500 to-cyan-600' }
];